// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","container":"input_container__9JhAI","title":"input_title__W7VXE","input":"input_input__WKhwi","filled":"input_filled__N8TM9","error":"input_error__xGR6G"};